import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const deleteModalQuestionsSlice = createSlice({
  name: "deleteModalQuestions",
  initialState,
  reducers: {
    openModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModalDelete, closeModalDelete } = deleteModalQuestionsSlice.actions;
export default deleteModalQuestionsSlice.reducer;
